import React from "react";

import { Switch, Route } from "react-router-dom";

import DailyReportTransactions from "./daily-report/Transactions";
import StudentFeesByClass from "./student-fees/StudentFeesByClass";
import DailyReportBalance from "./daily-report/Balance";
import AccountStatement from "./account-statement/AccountStatement";
import AccountsReport from "./AccountsReport";
import Discounts from "./revenues/Discounts";
import RevenueBudgets from "./revenues/Budgets";
import Revenues from "./revenues/Revenues";
import Expenses from "./expenses/Expenses";
import ExpensesBudgets from "./expenses/Budgets";
import Contractors from "./expenses/Contractors";
import StudentFeeStatement from "./student-fee-statement/StudentFeeStatement";
import StudentFeeReceipt from "./student-fee-receipt/StudentFeeReceipt";
import FacultiesPastBalance from "./FacultiesPastBalance";
import FacultiesIncomeList from "./FacultiesIncomeList";
import FacultiesSalary from "./FacultiesSalary";
import Transcript from "./transcript/Transcript";
import TeacherSalaryReport from "./teacher-salary-report/TeacherSalaryReport";
import TeacherDailySalaryPrint from "./teacher-salary-report/TeacherDailySalaryPrint";
import StaffSalaryReport from "./staff-salary-report/StaffSalaryReport";
import SubjectShoqa from "./results/SubjectShoqa";
import SubjectResults from "./results/SubjectResults";
import ClassStudents from "./ClassStudents";
import DisqualifiedStudents from "./results/DisqualifiedStudents";
import ExamResults from "./results/exam-results/ExamResults";
import CreditorPayments from "./creditor-payments/CreditorPayments";
import ClassResultBook from "./results/class-result-book/ClassResultBook";
import ExpenseAccounts from "./expenses/ExpensesAccounts";
import ExpensesSubAccounts from "./expenses/ExpensesSubAccounts";
import DebtPayments from "./expenses/DebtPayments";
import TeacherSalaryReceipt from "./teacher-salary-report/TeacherSalaryReceipt";
import StaffSalaryReceipt from "./staff-salary-report/StaffSalaryReceipt";
import CreditorPaymentReceipt from "./creditor-payments/CreditorPaymentReceipt";
import ExpensesPaymentReceipt from "./expenses/ExpensePaymentReceipt";
import RevenuePaymentReceipt from "./revenues/RevenuePaymentReceipt";
import ClassResultSummary from "./results/class-result-summary/ClassResultSummary";
import StudentAttendance from "./student-attendance/StudentAttendance";
import WeeklyTimetablePrint from "./parity/WeeklyTimetablePrint";
import WeeklyAttendancePrint from "./parity/WeeklyAttendancePrint";
import SubjectAttendancePrint from "./parity/SubjectAttendancePrint";
import ApplicantsPrint from "./parity/ApplicantsPrint";
import AbsenceWarningsPrint from "./parity/AbsenceWarningsPrint";
import ExamCardsPrint from "./parity/ExamCardsPrint";
import DailyAttendancePrint from "./parity/DailyAttendancePrint";

const Prints = () => {
  const basePath = "/print";

  return (
    <Switch>
      <Route
        path={`${basePath}/contractors`}
        render={(p) => <Contractors {...p} />}
      />
      <Route
        path={`${basePath}/transcript/:studentId`}
        render={(p) => <Transcript {...p} />}
      />
      <Route
        path={`${basePath}/facultiesPastBalance`}
        render={(p) => <FacultiesPastBalance {...p} />}
      />
      <Route
        path={`${basePath}/facultiesIncomeList/:fid/classes/:hyid`}
        render={(p) => <FacultiesIncomeList {...p} />}
      />
      <Route
        path={`${basePath}/expensesBudgets`}
        render={(p) => <ExpensesBudgets {...p} />}
      />
      <Route
         path={`${basePath}/expenses/type/:tid/account/:aid/halfYear/:halfYearId`}
         render={(p) => <ExpenseAccounts {...p} />}
      />
      <Route
         path={`${basePath}/expenses/type/:tid/account/:aid/subAccount/:said/halfYear/:halfYearId`}
         render={(p) => <ExpensesSubAccounts {...p} />}
      />
      <Route
         path={`${basePath}/expenses/debtType/:did/creditors/halfYear/:halfYearId`}
         render={(p) => <DebtPayments {...p} />}
      />
      <Route
         path={`${basePath}/expenses/salary/faculties/:fid/halfYearId/:halfYear`}
         render={(p) => <FacultiesSalary {...p} />}
      />
      <Route
        path={`${basePath}/expenses/:tid/:halfYearId?`}
        render={(p) => <Expenses {...p} />}
      />
      <Route
        path={`${basePath}/revenues/:tid/:halfYearId?`}
        render={(p) => <Revenues {...p} />}
      />
      <Route
        path={`${basePath}/revenueBudgets`}
        render={(p) => <RevenueBudgets {...p} />}
      />
      <Route
        path={`${basePath}/discounts`}
        render={(p) => <Discounts {...p} />}
      />
      <Route
        path={`${basePath}/finance/dashboard/accountReports`}
        render={(p) => <AccountsReport {...p} />}
      />
      <Route
        path={`${basePath}/student/fees/faculty/:fid/class/:cid`}
        render={(p) => <StudentFeesByClass {...p} />}
      />
      <Route
        path={`${basePath}/dailyReport/transactions/:type/:id/:date?`}
        render={(p) => <DailyReportTransactions {...p} />}
      />
      <Route
        path={`${basePath}/dailyReport/balance/:date?`}
        render={(p) => <DailyReportBalance {...p} />}
      />
      <Route
        path={`${basePath}/account-statement/:account`}
        render={(p) => <AccountStatement {...p} />}
      />
      <Route
        path={`${basePath}/student-fee-statement/:student`}
        render={(p) => <StudentFeeStatement {...p} />}
      />
      <Route
        path={`${basePath}/student-fee-receipt/:receipt_id`}
        render={(p) => <StudentFeeReceipt {...p} />}
      />
      <Route
        path={`${basePath}/teacher-salary-receipt/:teacher_id/:receipt_id`}
        render={(p) => <TeacherSalaryReceipt {...p} />}
      />
      <Route
        path={`${basePath}/teacher-daily-salary/:teacher_id`}
        render={(p) => <TeacherDailySalaryPrint {...p} />}
      />
      <Route
        path={`${basePath}/staff-salary-receipt/:staff_id/:receipt_id`}
        render={(p) => <StaffSalaryReceipt {...p} />}
      />
      <Route
        path={`${basePath}/creditor-payment-receipt/:creditor_id/:receipt_id`}
        render={(p) => <CreditorPaymentReceipt {...p} />}
      />
      <Route
        path={`${basePath}/expense-payment-receipt/types/:type/accounts/:account/subAccounts/:subAccount/expenses/:receipt_id/halfYear/:halfYear`}
        render={(p) => <ExpensesPaymentReceipt {...p} />}
      />
      <Route
        path={`${basePath}/revenue-payment-receipt/types/:type/accounts/:account/subAccounts/:subAccount/revenues/:receipt_id/halfYear/:halfYear`}
        render={(p) => <RevenuePaymentReceipt {...p} />}
      />
      <Route
        path={`${basePath}/teacher-salary-report/:teacher_id/:activeYear?`}
        render={(p) => <TeacherSalaryReport {...p} />}
      />
      <Route
        path={`${basePath}/staff-salary-report/:staff_id/:activeYear`}
        render={(p) => <StaffSalaryReport {...p} />}
      />
      <Route
        path={`${basePath}/creditor-payments/:creditor_id/:activeYear`}
        render={(p) => <CreditorPayments {...p} />}
      />
      <Route
        path={`${basePath}/results/shoqa/:classId/:subjectId/:entryYearId`}
        render={(p) => <SubjectShoqa {...p} />}
      />
      <Route
        path={`${basePath}/results/result/:classId/:subjectId/:entryYearId`}
        render={(p) => <SubjectResults {...p} />}
      />
      <Route
        path={`${basePath}/results/disqualified/:classId/:subjectId/:entryYearId`}
        render={(p) => <DisqualifiedStudents {...p} />}
      />
      <Route
        path={`${basePath}/results/class-result-book/:classId`}
        render={(p) => <ClassResultBook {...p} />}
      />
      <Route
        path={`${basePath}/results/class-result-summary/:classId`}
        render={(p) => <ClassResultSummary {...p} />}
      />
      <Route
        path={`${basePath}/results/exam-result/:studentId/:activeSem`}
        render={(p) => <ExamResults {...p} />}
      />
      <Route
        path={`${basePath}/student-attendance/:studentId/:activeSem`}
        render={(p) => <StudentAttendance {...p} />}
      />
      <Route
        path={`${basePath}/classes/:cid/students`}
        render={(p) => <ClassStudents {...p} />}
      />
      <Route
        path={`${basePath}/weekly-timetable/:classId`}
        render={(p) => <WeeklyTimetablePrint {...p} />}
      />
      <Route
        path={`${basePath}/weekly-attendance/:classId/:startDate`}
        render={(p) => <WeeklyAttendancePrint {...p} />}
      />
      <Route
        path={`${basePath}/subject-attendance/:classId/:subjectId/:type`}
        render={(p) => <SubjectAttendancePrint {...p} />}
      />
      <Route
        path={`${basePath}/applicants`}
        render={(p) => <ApplicantsPrint {...p} />}
      />
      <Route
        path={`${basePath}/absence-warnings`}
        render={(p) => <AbsenceWarningsPrint {...p} />}
      />
      <Route
        path={`${basePath}/exam-cards`}
        render={(p) => <ExamCardsPrint {...p} />}
      />
      <Route
        path={`${basePath}/staff-attendance/:date`}
        render={(p) => <DailyAttendancePrint kind="staff" {...p} />}
      />
      <Route
        path={`${basePath}/teacher-attendance/:date`}
        render={(p) => <DailyAttendancePrint kind="teachers" {...p} />}
      />
    </Switch>
  );
};

export default Prints;
